export default __webpack_public_path__ + "static/media/stacked-waves-haikei.c8e371ad.svg";